<template>

    <Modal ref="modal" :title="warning?.title" size="large">

        <div v-if="warning">
            <p class="mb-4">{{ warning?.body }}</p>

            <div class="gap-4 mt-6 grid grid-cols-2">
                <div></div>
                <Button v-if="warning" type="primary" size="large" @click="accept">Continue</Button>
            </div>
        </div>

    </Modal>

</template>
<script setup lang="ts">

import Button from "@/components/core/Button.vue";
import Modal from '@/components/core/modals/Modal.vue';
import {useWarningModal} from "@/composables/useWarningModal";

const modal = ref<InstanceType<typeof Modal>|null>(null);
const { warning } = useWarningModal();

watch(warning, () => {
    if(warning.value !== null) {
        modal.value?.open();
    }
}, {deep: true})

function open(event?: Event) {
    modal.value?.open();
}

function close(event?: Event) {
    modal.value?.close();
}

function accept(event?: Event) {
    if(warning.value?.callback) {
        warning.value?.callback();
    }
    close();
}

defineExpose({open, close});
</script>